export default {
    methods: {
        pastePrevent() {
            document.body.addEventListener('paste', e => {
                const elems = document.querySelectorAll('.input-text__input, .login__input-pin, .pin-change__input, .pin__input-pin');

                elems.forEach(item => {
                    if (e.target !== item) {
                        return;
                    }
                    e.preventDefault();
                });
            });
        }
    }
};